import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";

var Session = /*#__PURE__*/function () {
  function Session() {
    _classCallCheck(this, Session);

    this.metadata = {};
    this.userID = null;
    this.sessionID = null;
    this.callbacks = [];
  }

  _createClass(Session, [{
    key: "attachUpdateCallback",
    value: function attachUpdateCallback(cb) {
      this.callbacks.push(cb);
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(newInfo) {
      if (newInfo.userID == null) {
        delete newInfo.userID;
      }

      if (newInfo.sessionID == null) {
        delete newInfo.sessionID;
      }

      this.callbacks.forEach(function (cb) {
        return cb(newInfo);
      });
    }
  }, {
    key: "update",
    value: function update(newInfo) {
      var _this = this;

      if (newInfo.userID !== undefined) {
        // TODO clear nullable/undefinable types
        this.userID = newInfo.userID;
      }

      if (newInfo.metadata !== undefined) {
        Object.entries(newInfo.metadata).forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              k = _ref2[0],
              v = _ref2[1];

          return _this.metadata[k] = v;
        });
      }

      if (newInfo.sessionID !== undefined) {
        this.sessionID = newInfo.sessionID;
      }

      this.handleUpdate(newInfo);
    }
  }, {
    key: "setMetadata",
    value: function setMetadata(key, value) {
      this.metadata[key] = value;
      this.handleUpdate({
        metadata: _defineProperty({}, key, value)
      });
    }
  }, {
    key: "setUserID",
    value: function setUserID(userID) {
      this.userID = userID;
      this.handleUpdate({
        userID: userID
      });
    }
  }, {
    key: "getInfo",
    value: function getInfo() {
      return {
        sessionID: this.sessionID,
        metadata: this.metadata,
        userID: this.userID
      };
    }
  }, {
    key: "reset",
    value: function reset() {
      this.metadata = {};
      this.userID = null;
      this.sessionID = null;
    }
  }]);

  return Session;
}();

export { Session as default };